import React from "react";

export default function TypingDots() {
  return (
    <div className="flex items-center gap-1">
      <span className="bg-grayTrue400 inline-block size-2 animate-bounce rounded-full delay-150" />
      <span className="bg-grayTrue400 inline-block size-2 animate-bounce rounded-full delay-300" />
      <span className="bg-grayTrue400 inline-block size-2 animate-bounce rounded-full" />
    </div>
  );
}
